import UserPolymerization from "../views/userConfigurationManagement/userPolymerization";
import UserPreferences from "../views/userConfigurationManagement/userPreferences";
import Main from "../views/main";
const UserConfigurationManagementRouter = {
  path: "/user-polymerization",
  component: Main,
  title: "用户配置管理",
  icon: "el-icon-user-solid",
  meta: { keepAlive: true },
  children: [
    {
      path: "/user-polymerization",
      component: UserPolymerization,
      name: "userPolymerization",
      title: "用户聚合",
      meta: { title: "用户聚合", keepAlive: true },
    },
    {
      path: "/user-preferences",
      component: UserPreferences,
      name: "userPreferences",
      title: "用户喜好项",
      meta: { title: "用户喜好项", keepAlive: true },
    },
  ],
};
export default UserConfigurationManagementRouter;
